import React from 'react';
import { GiftIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { OfferCountdown } from './OfferCountdown';
export function Bonuses() {
  const bonuses = [{
    title: 'Biblioteca Premium de Modelos Laborales™',
    details: 'Más de 100 modelos editables.',
    price: 'AR$ 19.990'
  }, {
    title: 'Cláusulas Laborales PRO™',
    details: 'Formularios, checklists, planillas y organización de expedientes.',
    price: 'AR$ 14.990'
  }, {
    title: 'Escritos Urgentes Laborales',
    details: 'Escritos urgentes laborales con medidas cautelares, recursos, pronto despacho, habilitaciones, oficios y presentaciones procesales completamente redactadas',
    price: 'AR$ 9.990'
  }, {
    title: '100 Formularios, Checklists y Herramientas Listas para Usar',
    details: 'Fichas de clientes, entrevistas, control de plazos, seguimiento de casos, convenios, informes y planillas listas para completar y utilizar desde el primer día.',
    price: 'AR$ 7.990'
  }];
  return <section className="border-y border-white/10 bg-charcoal px-5 py-14 md:px-8 md:py-20" data-id="element-26" data-mp="3dfd2hjen40sv">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="3ddiqiulcjj0x">
        <FadeIn className="text-center" data-id="element-28" data-mp="3r7029t7sjrge">
          <div className="mx-auto flex w-fit items-center gap-2 text-accent" data-id="element-29" data-mp="3r8ul91zi59hu">
            <GiftIcon size={18} aria-hidden="true" data-id="element-30" data-mp="3n5oiw5fig2gn" />
            <p className="text-sm font-bold uppercase tracking-[0.18em]" data-id="element-31" data-mp="2zfamk2pw7hg9">
              Bonos exclusivos
            </p>
          </div>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-32" data-mp="2uhsnr55lailz">
            4 recursos adicionales incluidos hoy
          </h2>
          <p className="mt-3 text-sm text-stone-400" data-id="element-33" data-mp="33h5p1ajk80vm">
            Sin costo adicional con tu tratado.
          </p>
        </FadeIn>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-34" data-mp="np89wdpqt5ho">
          {bonuses.map((bonus, index) => <FadeIn key={bonus.title} delay={index * 0.06} data-id="element-35" data-mp="ipwtj5tag20m" data-mpi={index}>
              <article className="relative border border-accent/30 bg-ink p-6" data-id="element-36" data-mp="3ciwq0mda3dhk">
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-accent" data-id="element-37" data-mp="3cl0sczvj44fq">
                  Bono {index + 1}
                </span>
                <h3 className="mt-3 font-display text-xl font-bold text-white" data-id="element-38" data-mp="3ljcplkqwi0h5">
                  {bonus.title}
                </h3>
                <p className="mt-3 min-h-10 text-sm leading-relaxed text-stone-400" data-id="element-39" data-mp="3qhwffw8m7wes">
                  {bonus.details}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-white/10 pt-4" data-id="element-40" data-mp="2xtqtx79qm3dw">
                  <span className="text-sm text-stone-500 line-through" data-id="element-41" data-mp="32td6rflnlhm6">
                    {bonus.price}
                  </span>
                  <span className="bg-accent px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-ink" data-id="element-42" data-mp="37klhqg2mtb1g">
                    Gratis
                  </span>
                </div>
              </article>
            </FadeIn>)}
        </div>

        <OfferCountdown data-id="element-43" data-mp="27jzs7akb9b40" />

        <p className="mx-auto mt-7 max-w-2xl text-center text-sm leading-relaxed text-stone-400" data-id="element-44" data-mp="27k9offvy8ei5">
          Todo está incluido hoy para que puedas resolver expedientes con mayor
          rapidez, seguridad jurídica y respaldo profesional.
        </p>
      </div>
    </section>;
}